<template class="full-height">
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="role-app-container" style="position: relative; height: 100%">
    <role-data />
  </div>
</template>

<script>
export default {
  name: 'RoleManagement',
  components: {
    roleData: () => import('@/views/ita/auth/role/components/roleList.vue'),
  },
  data() {
    return {
      list: null,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {},
    handleDownload() {},
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}
</style>
